﻿import { Component } from '@angular/core';
import { RestService } from 'src/app/_services/rest.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Validators, FormGroup, FormControl } from '@angular/forms';
import { Observable, BehaviorSubject } from 'rxjs';
import { User } from '../../_models';


@Component({ templateUrl: 'edit.user.component.html' })
export class EditUserComponent {

    oUser: Observable<any>;
    userForm: FormGroup;
    user: any;
    saving = false;
    submitted = false;

    constructor(private restService: RestService, private route: ActivatedRoute, private router: Router) {
        this.route.params.subscribe(params => {
            if (params['id'] > 0) {
                this.oUser = this.getUser(params['id']);
            } else {
                const tmp = new User();
                tmp.id = 0;
                this.oUser = new BehaviorSubject<any>(tmp).asObservable();
            }
            this.oUser.subscribe(user => {
                this.createForm(user);
            });
        });

    }

    private createForm(user: any) {
        this.user = user;
        this.userForm = new FormGroup({
            'firstName': new FormControl(user.firstName),
            'lastName': new FormControl(user.lastName),
            'password': new FormControl(user.password, [Validators.required, Validators.minLength(4)]),
            'tokenMercadoPago': new FormControl(user.tokenMercadoPago),
            'email': new FormControl(user.email, Validators.required),
            'enabled': new FormControl(user.enabled),
            'tokenExpired': new FormControl(user.tokenExpired),
            'role_user': new FormControl(this.hasRol('ROLE_USER')),
            'role_root': new FormControl(this.hasRol('ROLE_ROOT'))
        });
    }

    get firstName() { return this.userForm.get('firstName'); }

    get lastName() { return this.userForm.get('lastName'); }

    get email() { return this.userForm.get('email'); }

    get enabled() { return this.userForm.get('enabled'); }

    get tokenExpired() { return this.userForm.get('tokenExpired'); }

    get tokenMercadoPago() { return this.userForm.get('tokenMercadoPago'); }

    

    private getUser(id: string): Observable<any> {
        return this.restService.get('/rest-api/root/user/' + id);
    }

    hasRol(rolName: string): boolean {
        if (this.user && this.user.roles) {
            let encontro: boolean = false;
            this.user.roles.forEach(rol => {
                if (rolName === rol.name) {
                    encontro = true;
                }
            });
            return encontro;
        } else {
            return false;
        }
    }

    cancelar() {
        this.router.navigate(['/root/users/']);
    }

    get f() { return this.userForm.controls; }

    onSubmit() {
        this.submitted = true;

        // stop here if form is invalid
        if (this.userForm.invalid) {
            return;
        }
debugger;
        this.saving = true;
        const value = this.userForm.value;
        const temp: any = {};
        temp.id = this.user.id;
        temp.firstName = value.firstName;
        temp.lastName = value.lastName;
        temp.email = value.email;
        temp.enabled = value.enabled;
        temp.accountNonExpired = !value.tokenExpired;
        temp.password = value.password;
        temp.tokenMercadoPago = value.tokenMercadoPago;
        temp.roles = [];
        if (value.role_root) {
            temp.roles.push({ id: 1, name: "ROLE_ROOT" })
        }
        if (value.role_user) {
            temp.roles.push({ id: 2, name: "ROLE_USER" })
        }

        this.restService.post('/rest-api/root/user', temp)
            .subscribe(
                data => {
                    this.saving = false;
                    this.cancelar();
                })
            ;

    }

}
